import { Card } from "../../components/Card";
import { CertificationTable } from "./components/CertificationTable";
import { useUser } from "../../services/user-context";
import { useCertification } from "./context/certification-context";
import { useUserCertifications } from "./hooks/use-user-certifications";

export function UserCertifications() {
  const { userInfo } = useUser() as any;
  const userId = userInfo?.id || userInfo?.["sub"];

  const {
    certifications: certificationList,
    users,
    setSelectedCertificationAssignment,
  } = useCertification();

  const {
    certifications,
    isLoadingCertifications,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useUserCertifications(userId);

  return (
    <Card className="!px-0 !py-0">
      <CertificationTable
        type="user-dashboard"
        userId={userId}
        certifications={certifications}
        certificationList={certificationList}
        isLoading={isLoadingCertifications}
        users={users}
        setSelectedCertificationAssignment={setSelectedCertificationAssignment}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
      />
    </Card>
  );
}
